import React from "react";
import "./Navbar.scss"
import phone from "../../assets/icons/phone.svg"
import mail from "../../assets/icons/email.svg"
import clock from "../../assets/icons/clock.svg"
import logo from "../../assets/logo.png"
import menu from "../../assets/icons/menu.svg"



const Navbar = ({ selected }) => {

    const pages = [
        // {
        //     pageId: "HOME",
        //     title: "Home"
        // },
        // {
        //     pageId: "MENU",
        //     title: "Menu"
        // }, {
        //     pageId: "CONTACT_US",
        //     title: "Contact Us"
        // }
    ]
    return (
        <div className="Virasat-Navbar">
            <div className="Virasat-Navbar-header">
                <div className="Virasat-Navbar-header-left">
                    <div className="navbar-header-item">
                        <img alt="" src={phone} className="navbar-header-item-icon" />
                        <div className="navbar-header-item-text">
                            +44 1784 463978
                        </div>
                    </div>
                    <div className="navbar-header-item">
                        <img alt="" src={mail} className="navbar-header-item-icon" />
                        <div className="navbar-header-item-text">
                            info@virasat.uk
                        </div>
                    </div>
                </div>
                <div className="Virasat-Navbar-header-right">
                    <div className="navbar-header-item">
                        <img alt="" src={clock} className="navbar-header-item-icon" />
                        <div className="navbar-header-item-text">
                            {/* Mon - Fri / 10:00-21:00, Sat - Sun / 09:00 - 23:00 */}
                            Coming Soon
                        </div>
                    </div>
                </div>
            </div>
            <div className="Virasat-Navbar-tab">
                <div className="logo-name-tab"><img alt="" className="logo-name-tab-img" src={logo} />IRASAT</div>
                <div className="Virasat-Navbar-tab-right">
                    {pages.map((page) => {
                        return (
                            <div className={`virasta-tab-nav ${selected === page.pageId ? "selected" : ""}`}>
                                {page.title}
                            </div>
                        )
                    })}
                </div>
                {/* <div className="Virasat-Navbar-tab-menu">
                    <img alt="" src={menu} />
                </div> */}
            </div>
        </div>
    )
}
export default Navbar